<template>
  <a :href="href" target="_blank" rel="noopener" class="powered-by">
    <img :src="light ? logoIconBleu : logoIcon" alt="" class="powered-by-logo" /> Propulsé par DartsHub
  </a>
</template>

<script setup lang="ts">
import logoIcon from '@/assets/logo-icon.png';
import logoIconBleu from '@/assets/logo-icon-bleu.png';

// Mention de la source en bas d'une page intégrée sur un autre site (LeaderboardEmbed,
// mode ?embed=true d'App.vue). light : fond clair, le logo standard a une moitié blanche
// invisible, variante bleue.
defineProps<{ href: string; light: boolean }>();
</script>

<style scoped>
.powered-by {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  /* Couleur du texte du thème (l'accent est vert sur le thème cmer). L'embed public
     garde sa couleur d'accent (cf. LeaderboardEmbed.vue, .embed-footer a). */
  color: var(--color-fg);
  text-decoration: none;
}

.powered-by-logo {
  height: 20px;
}
</style>
